/**
 * LoginPage - User login with invitation-only messaging
 * Feature: 647-invite-registration
 */

import { useSearchParams } from 'react-router-dom';
import { Container, Stack } from '@/components/layout';
import { LoginForm } from '@/components/composed';
import { Heading, Text } from '@/components/atoms';

export function LoginPage() {
  const [searchParams] = useSearchParams();
  const resetSuccess = searchParams.get('resetSuccess') === 'true';
  const returnUrl = searchParams.get('returnUrl');

  return (
    <Container maxWidth="sm">
      <Stack direction="vertical" spacing={4}>
        <Heading level="h1">Login</Heading>
        {resetSuccess && (
          <div className="text-success bg-success/10 border border-success/30 rounded p-3">
            ✓ Password reset successfully! Please log in with your new password.
          </div>
        )}
        {returnUrl && (
          <Text className="text-muted text-sm">
            Please log in to continue.
          </Text>
        )}
        <LoginForm />
        <div className="text-center text-sm text-muted pt-4 border-t border-border">
          <Text>
            Don't have an account? 206mp is currently <strong>invitation only</strong>.
          </Text>
          <Text className="mt-1">
            Contact an existing member for an invite link.
          </Text>
        </div>
      </Stack>
    </Container>
  );
}
